<template>
	<div>
		<!-- <v-card-actions>			
			<v-spacer></v-spacer>	
			<v-btn color="warning" @click="downloadWithCSS">
				<v-icon>cloud_download</v-icon> PDF
			</v-btn>			
			<v-btn color="info" @click="exportTableToExcel('tblData', 'members-data')">
				<v-icon>description</v-icon> Excel
			</v-btn>
		</v-card-actions> -->

		<v-toolbar
		dark
		fixed
		app
		height="50"
		class="toolBar"
		>
		<v-spacer></v-spacer>

		<v-toolbar-items>
			<v-icon class="white--text" @click="downloadWithCSS('ContractImplementationReport')">cloud_download</v-icon>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
			<v-icon class="white--text" @click="printdiv">print</v-icon>
		</v-toolbar-items>
	</v-toolbar>

<!-- {{items}} -->

<v-container grid-list-md :class="{opacityC:isTrue}">
	<v-layout wrap>
		<v-flex xs10 offset-xs1>
			<div style="background:#FFF; padding:20px;">
				<div ref="content" id="print_div">				
					<table class="reportTbl" width="100%" id="tblData">
						<tbody>
							<tr class="tb-td">
								<td colspan="8">Project Monitoring Form: IMED 03/2203</td>
							</tr>
							<tr class="tb-td">
								<td colspan="8">Quarterly Progress Report</td>
							</tr>
							<tr class="tb-td">
								<td colspan="8">ADP 2019-20, Reporting Quarter</td>
							</tr>
							<tr class="tb-td">
								<td colspan="8">D. Contract Implementation Report</td>
							</tr>
							<tr class="tb-td">
								<td colspan="8" style="font-size:11px">Reporting Period : Up to</td>
							</tr>
							<tr>
								<td colspan="3" class="borderNone">
									D.1	Project Title:	
									{{items.length>0 ? items[0].project_name : ""}}
								</td>
								<td colspan="5" rowspan="2" class="borderNone">
									<table class="reportTbl" width="100%">
										<tbody>
											<tr>
												<td></td>
												<td class="textCenter">Project Code</td>
											</tr>
											<tr>
												<td>ADP</td>
												<td>
												{{items.length>0 ? items[0].adp_code : ""}}
												</td>
											</tr>
											<tr>
												<td>Non ADP</td>
												<td>
													{{items.length>0 ? items[0].non_adp_code : ""}}
												</td>
											</tr>
										</tbody>
									</table>
								</td>
							</tr>
							<tr>
								<td colspan="3" class="borderNone">D.2	Contract Implementation:</td>
							</tr>
							<tr>
								<td rowspan="2">Description of contracts (as per tender Document)</td>
								<td rowspan="2" class="textCenter">Contract Value</td>
								<td rowspan="2" class="textCenter">Date of Workorder/ Contract Agreement</td>
								<td rowspan="2" class="textCenter">Completion Date as per Contract</td>
								<td colspan="4" class="textCenter">Progress</td>
							</tr>
							<tr>
								<td colspan="2">Amount Paid</td>
								<td colspan="2">Physical</td>
							</tr>
							<tr v-for="item in items">
								<td> {{item.TITLE}} </td>
								<td class="textRight">{{item.contract_value}}</td>
								<td class="textCenter">{{item.work_order_Date}}</td>
								<td class="textCenter">{{item.completaion_date}}</td>
								<td class="textRight">{{item.Amount_paid}}</td>
								<td></td>
								<td class="textRight">{{item.physical}}</td>
								<td>SM</td>
							</tr>

							<tr v-for="i in 100">
								<td> {{i}} </td>
								<td class="textRight">fgdfgdgdfgdf</td>
								<td class="textCenter">fgdfgdgdfgdf</td>
								<td class="textCenter">fgdfgdgdfgdf</td>
								<td class="textRight">fgdfgdgdfgdf</td>
								<td></td>
								<td class="textRight">fgdfgdgdfgdf</td>
								<td>SM</td>
							</tr>		

											
						</tbody>
					</table>
				</div>
			</div>
		</v-flex>
	</v-layout>
</v-container> 


</div>
</template>

<script>
import jsPDF from "jspdf";
import html2canvas from "html2canvas"
const commonService = require("../../../services/common.service");
export default {
	props:['paramVal'],
	data: () => ({
		
		items:[],
		subItems:[],
		isTrue:false,
		
	}),

	created(){		
		//console.log('created');
		this.getData();
	},

	watch: {
		paramVal() {
			this.getData();
		}
	},

	methods: {

		getData(){

			let root = this;
			let formSchema = '';
			let p = this.paramVal;
			
			if(typeof p == "undefined")
			{
				this.isTrue = false;
				formSchema = JSON.parse(sessionStorage.getItem('report'));
			}
			else
			{
				this.isTrue = true;
				formSchema = this.paramVal;
			}
			
			/*let formSchema = {
				'project_id': 1,
				'report_type': 1,
			}*/

			commonService.dataByMulParameters(formSchema, "contract-imp-report").then(res => {
				//console.log('res', res);
				if(res)
				{
					if(res.mainQueryData.length>0)
					{
						this.items = res.mainQueryData
					}

					if(formSchema.report_type == 0)
					{	
						setTimeout(function(){							
							root.exportTableToExcel('tblData', 'Monthly-Progress-Report');
						},1000);							
					}					
				}

			});
		},


		downloadWithCSS(filename='') 
		{
	       var quotes = document.getElementById('print_div');
	       html2canvas(quotes).then((canvas) => {
	            //! MAKE YOUR PDF
	            var pdf = new jsPDF('p', 'pt', 'letter');	  


	            for (var i = 0; i <= quotes.clientHeight/980; i++) {
	                //! This is all just html2canvas stuff
	                var srcImg  = canvas;
	                var sX      = 0;
	                var sY      = 980*i; // start 980 pixels down for every new page
	                var sWidth  = 900;
	                var sHeight = 1000;
	                var dX      = 0;
	                var dY      = 0;
	                var dWidth  = 900;
	                var dHeight = 980;

	                window.onePageCanvas = document.createElement("canvas");
	                onePageCanvas.setAttribute('width', 900);
	                onePageCanvas.setAttribute('height', 980);
	                var ctx = onePageCanvas.getContext('2d');
	                // details on this usage of this function: 
	                // https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API/Tutorial/Using_images#Slicing
	                ctx.drawImage(srcImg,sX,sY,sWidth,sHeight,dX,dY,dWidth,dHeight);

	                // document.body.appendChild(canvas);
	                var canvasDataURL = onePageCanvas.toDataURL("image/png", 1.0);

	                var width         = onePageCanvas.width;
	                var height        = onePageCanvas.clientHeight;

	                //! If we're on anything other than the first page,
	                // add another page
	                if (i > 0) {
	                    pdf.addPage(); //8.5" x 11" in pts (in*72)
	                }
	                //! now we declare that we're working on that page
	                pdf.setPage(i+1);
	                //! now we add content to that page!
	                pdf.addImage(canvasDataURL, 'PNG', 20, 40, (width*.62), (height*.62));

	            }
	            filename = filename?filename+'.pdf':'pdf-file.pdf';
	            //! after the for loop is finished running, we save the pdf.
	            pdf.save(filename);
	        });      
	    },


		XXXXdownloadWithCSS(filename='') 
		{
			/*const doc = new jsPDF({
				orientation: "a4",
		        // unit: "pt",
		        format: [740, 1000]
		    });*/

			/*var canvasElement = document.createElement('canvas');
			html2canvas(this.$refs.content, { canvas: canvasElement }).then(function (canvas) {

			var imgData = canvas.toDataURL('image/png');
			var imgWidth = 200; 
			var pageHeight = 295;  
			var imgHeight = canvas.height * imgWidth / canvas.width;
			var heightLeft = imgHeight;
			var doc = new jsPDF('p', 'mm');
			var position = 0;*/



			var canvasElement = document.createElement('canvas');

			/*html2canvas(this.$refs.content, {canvas: canvasElementn onclone: function(document) {
  			document.querySelector('.reportTbl').style.marginLeft = 20;
			}}).then(function (canvas) {*/

			html2canvas(this.$refs.content, { canvas: canvasElement }).then(function (canvas) {
			var imgData = canvas.toDataURL('image/png');
			var imgWidth = 209; 
			var pageHeight = 295;  

			console.log('canvas', canvas);
			var imgHeight = canvas.height * imgWidth / canvas.width;
			var heightLeft = imgHeight;
			//var doc = new jsPDF('a', 'mm');
			var doc = new jsPDF('p', 'mm', 'a4');
			var position = 10;


			doc.addImage(imgData, 'PNG', 1, position, imgWidth, imgHeight);
			heightLeft -= pageHeight;

			while (heightLeft >= 0) {
				position = (heightLeft - imgHeight);
				doc.addPage();
				doc.addImage(imgData, 'PNG', 1, position, imgWidth, imgHeight);
				heightLeft -= pageHeight;
			}
			//blob = doc.output('blob');
			doc.save( 'file.pdf');
			});
		},

		exportTableToExcel: function(tableID, filename = ''){
			var downloadLink;
			var dataType = 'application/vnd.ms-excel';
			var tableSelect = document.getElementById(tableID);
			var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

			// Specify file name
			filename = filename?filename+'.xls':'excel_data.xls';

			// Create download link element
			downloadLink = document.createElement("a");

			document.body.appendChild(downloadLink);

			if(navigator.msSaveOrOpenBlob){
				var blob = new Blob(['\ufeff', tableHTML], {
					type: dataType
				});
				navigator.msSaveOrOpenBlob( blob, filename);
			}else{
			// Create a link to the file
			downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

			// Setting the file name
			downloadLink.download = filename;

			//triggering the function
			downloadLink.click();
		}		
	},

	checkDateFormate(){

	},

	printdiv: function () {
		this.printContentStatus = true;
		const divToPrint = document.getElementById("print_div");
		this.printContentStatus = false;
		const newWin = window.open("", "Print-Window");
		newWin.document.open();
		newWin.document.write(
			'<style type="text/css">'+
			'table.reportTbl{width:100%;border-collapse:collapse}.reportTbl td{border:1px solid #ccc;padding:6px}.reportTbl tr td{text-align:left;line-height:15px}.txtRight{text-align:right!important}.reportTbl tr.txtCenter td{text-align:center}.reportTbl tr.tb-td td{font-weight:700;text-align:center;border:none}td.textCenter{text-align:center!important}td.textRight{text-align:right !important}td.borderNone{border:none !important;}'+
			"</style>"
			);
		newWin.document.write(
			'<html><head><link rel="stylesheet" href="src/assets/css/style.css" type="text/css" /></head><body onload="window.print()">' +
			divToPrint.innerHTML +
			"</body></html>"
			);

		newWin.document.close();
		setTimeout(function () {
			newWin.close();
		}, 10);
	},

}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
table.reportTbl{
	width:100%;
	border-collapse: collapse;
}
.reportTbl td{
	border:1px solid #CCC;
	padding: 6px;
}
.reportTbl tr td{	
	text-align:left;
	line-height: 15px;
}
.txtRight{	
	text-align:right !important;
}
.reportTbl tr.txtCenter td{	
	text-align:center;
}
.reportTbl tr.tb-td td{
	font-weight: bold;
	text-align:center;
	border:none;
}
td.textCenter{
	text-align: center !important;
}
td.textRight{
	text-align: right !important;
}
td.borderNone{
	border:none !important;
}
.subTable tr td{
	/*text-align: center !important;*/
}
</style>



// WEBPACK FOOTER //
// src/components/reportGenerate/reportsB/ContractImplementationReport.vue